export function arrayByLength(length: number) {
  return [...Array(length).keys()];
}